$(document).ready(function() {
  $("#accordian a").click(function() {
    var link = $(this);
    var closest_ul = link.closest("ul");
    var parallel_active_links = closest_ul.find(".active");
    var closest_li = link.closest("li");
    var link_status = closest_li.hasClass("active");
    var count = 0;

    closest_ul.find("ul").slideUp(function() {
      if (++count == closest_ul.find("ul").length){
        parallel_active_links.removeClass("active");
      }    
    });

    if (!link_status) {
      closest_li.children("ul").slideDown();
      closest_li.addClass("active");
    }
  });


  /* Sidebar Top filters */
  
  var apSidebarContainer = document.querySelector(".ap_sidebar_top");
  var apSidebarFilterTop = apSidebarContainer.querySelectorAll(".tt-collapse");
  
  apSidebarFilterTop.forEach(function(node){
    node.addEventListener("click", function(){
      var _indexNode = Array.from(apSidebarFilterTop).indexOf(node);
      apDropdowClose(apSidebarFilterTop, _indexNode);
    });
  });

  function apDropdowClose(apDropdownList, _indexNode = null){
    apDropdownList.forEach(function(node, index){
      if(!(node.classList.contains("tt-filter-detach-option"))){
        if(_indexNode == null){
          node.classList.remove("open");
        }else if(_indexNode != index ){
          node.classList.remove("open");
        }
      }
    });
  };

  /* close tt-collapse all */
  apDropdowClose(apSidebarFilterTop);

  /* hide remove filters */
  filterRemove = document.querySelector(".filtres-remove-js");
  if(filterRemove){filterRemove.parentNode.classList.add('ap_no-remove-filters');}

  /* hide remove filters */
  filterPrice = document.querySelector(".ttpricefilter-js");
  if(filterPrice){filterPrice.parentNode.classList.add('ap_reset-overflow');}

  /* close tt-collapse when document is clicked */
  document.addEventListener("click", function (event) {
    event.stopPropagation();
    if(event.target.contains(apSidebarContainer)){
      apDropdowClose(apSidebarFilterTop);
    }
  });
});